import type { MeResponse, SaleType, VatMode } from '@kassa/shared';

// Pul: 2 onluq, azərbaycanca vergül, sonda ₼. Yoxdursa — ən.
// Lokaldan asılı deyil (KT-86): bəzi brauzerlərdə və .exe webview-da az-AZ yoxdur → «1,000.00» çıxırdı.
// Qruplama bölünməz boşluqla (U+00A0), onluq vergüllə: 1 234 567,89. Dar boşluq (U+202F) bəzi şriftlərdə (qalın Inter)
// görünmürdü — «1234 567,89» (KT-95).
const NNBSP = '\u00a0';
function azNumber(value: number, opts: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat('en-US', opts).format(value).replace(/,/g, NNBSP).replace('.', ',');
}

export function formatMoney(value: number | null): string {
  if (value === null || !Number.isFinite(value)) return '—';
  return `${azNumber(value, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₼`;
}

// Sənəd növü (stock_move-un sənədi): anbar hərəkətinin səbəbi.
export const DOC_KIND_LABEL: Record<string, string> = {
  QEB: 'Qəbul',
  ALS: 'Alış',
  SAT: 'Satış',
  VER: 'Verilmə',
  QAY: 'Qaytarma',
  TRF: 'Transfer',
  KOC: 'Köçürmə',
  SAY: 'Sayım',
  SIL: 'Silinmə',
  LEG: 'Ləğv',
};

// Miqdar: ən çox 3 onluq, vergüllə.
export function formatQty(value: number): string {
  return azNumber(value, { maximumFractionDigits: 3 });
}

export const SALE_TYPE_LABEL: Record<SaleType, string> = {
  piece: 'Ədədlə',
  weight: 'Çəki ilə',
  measure: 'Həcm / uzunluq',
  service: 'Xidmət',
};

export const VAT_LABEL: Record<VatMode, string> = {
  vat18: 'ƏDV 18%',
  vat0: 'ƏDV 0%',
  exempt: 'ƏDV-dən azad',
  agri: 'Kənd təsərrüfatı (ƏDV yalnız ticarət əlavəsinə)',
};

export const UNIT_LABEL: Record<string, string> = {
  pcs: 'ədəd',
  bag: 'kisə',
  box: 'qutu',
  kg: 'kq',
  g: 'q',
  t: 'ton',
  l: 'litr',
  m: 'metr',
  m2: 'm²',
  svc: 'xidmət',
};

/** Ekranda düymə/bölmə göstərmək üçün (yalnız rahatlıq — əsl yoxlama API-dədir). */
export function hasPermission(me: MeResponse, code: string): boolean {
  return me.permissions.includes(code);
}

/** Azərbaycan tarixi: dd.mm.yyyy */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getDate())}.${p(d.getMonth() + 1)}.${d.getFullYear()}`;
}

/** Tarix və saat: dd.mm.yyyy HH:MM (brauzerin saatı ilə) */
export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  const p = (n: number) => String(n).padStart(2, '0');
  return `${formatDate(iso)} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

/**
 * Sətir məbləği (göstəriş): qty × qiymət − endirim, tam ədədlə, yarım qəpik yuxarı — serverlə eyni (KT-86).
 * float vurma 0.5 × 1 234 567.89-u 617 283,94 göstərirdi (düz: 617 283,95).
 */
export function lineAmount(qty: number, price: number, discount = 0): number {
  const sc = (n: number, d: number) => BigInt(Math.abs(n).toFixed(d).replace('.', '')) * (n < 0 ? -1n : 1n);
  const raw = sc(qty, 3) * sc(price, 4); // 10^7 miqyası
  const kop = raw >= 0n ? (2n * raw + 100_000n) / 200_000n : -((-2n * raw + 100_000n) / 200_000n);
  return Number(kop - sc(discount, 2)) / 100;
}

/** Məbləğ → tam qəpik (ədəd, ondalıq yazılışdan; vurma yoxdur). Ekranda cəm/qalıq hesabı üçün (KT-95). */
export function kop(n: number): number {
  const v = Number(Math.abs(n).toFixed(2).replace('.', ''));
  return n < 0 ? -v : v;
}
